module.exports = __webpack_public_path__ + "static/media/similar_frustum.3693e4c6.jpg";